import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

function formatActor(value) {
	if (!value) return null;
	return value === 'SYNC_JOB' ? 'System migration' : value;
}

export default function VersionActorLine({ createdByEmail, modifiedByEmail, updatedAt }) {
	const created = formatActor(createdByEmail);
	const modified = formatActor(modifiedByEmail);
	if (!created && !modified) return null;
	return (
		<div className="dsv-version-item__meta" data-testid="version-actor-line">
			{created && (
				<span className="dsv-version-item__meta-item">Created by {created}</span>
			)}
			{modified && (
				<span className="dsv-version-item__meta-item">
					Last modified by {modified}
					{updatedAt ? ` on ${moment(updatedAt).format('D MMM YYYY, h:mm A')}` : ''}
				</span>
			)}
		</div>
	);
}

VersionActorLine.propTypes = {
	createdByEmail: PropTypes.string,
	modifiedByEmail: PropTypes.string,
	updatedAt: PropTypes.string,
};
